import React, { Component } from 'react';
import LoginForm from '../../components/loginForm';

import './login.css';
import Navbar from "react-bootstrap/Navbar";
import {LinkContainer} from "react-router-bootstrap";
import { getAsset } from '../../utils/getAssets';

const GenialLogoWhite = getAsset("Genials-Logo-White");

class LoginPage extends Component{
    render(){
        return(
            <div className="page">
                <Navbar bg="dark" variant="dark" expand="lg" fixed="top">
                    <Navbar.Brand>
                        <LinkContainer to="./">
                            <img src={GenialLogoWhite} alt="Genial Lessons v2" height="30px" width="auto"/>
                        </LinkContainer>
                    </Navbar.Brand>
                    {
                        process.env.REACT_APP_ENV === "development" &&
                        <span className="noticesDev">Dev</span>
                    }
                    {
                        process.env.REACT_APP_ENV === "uat" &&
                        <span className="noticesUat">Uat</span>
                    }
                </Navbar>
                <LoginForm language={this.props.language}/>
            </div>
        );
    }
}

export default LoginPage;